import { useQuery } from "@tanstack/react-query";
import { getContract } from "@/requests/contract/get";
import { ReactQueryKeys } from "@/constants/common";
import { getRequest } from "@/requests/request/get";
import { usePathname } from "next/navigation";
import { useRedirect } from "@/hooks/useRedirect";

export const useGetContract = (uuid: string) => {
  const pathname = usePathname();
  const isRequest = pathname.includes("/request");

  const query = useQuery({
    queryKey: ReactQueryKeys.getContract(uuid, isRequest),
    queryFn: () => (isRequest ? getRequest(uuid) : getContract(uuid)),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    throwOnError: true,
    enabled: !!uuid,
  });

  useRedirect(uuid, query.data);

  return query;
};
